import React from 'react';
import './privacy.css';

const PrivacyPage = () => {
  return (
    <div className="privacy-page">
      <h1 className="privacy-title">Privacy Policy</h1>
      <div className="privacy-content">
        <h2>1. Introduction</h2>
        <p>
          Welcome to our 3D room design website. This Privacy Policy governs the manner in which we collect, use, maintain, and disclose information collected from users of the website.
        </p>

        <h2>2. Information Collection</h2>
        <p>
          We may collect personal identification information from users in various ways, including but not limited to when users visit our website, register on the website, or fill out a form.
        </p>

        <h2>3. Information Usage</h2>
        <p>
          Any information we collect from users may be used to personalize the user experience, improve our website, send periodic emails, or respond to inquiries.
        </p>

        <h2>4. Information Protection</h2>
        <p>
          We adopt appropriate data collection, storage, and processing practices and security measures to protect against unauthorized access, alteration, disclosure, or destruction of user information.
        </p>

        <h2>5. Cookies</h2>
        <p>
          Our website may use "cookies" to enhance user experience. Users may choose to set their web browser to refuse cookies or to alert you when cookies are being sent.
        </p>

        <h2>6. Third-Party Websites</h2>
        <p>
          Users may find advertising or other content on our website that links to the sites and services of our partners, suppliers, advertisers, sponsors, licensors, and other third parties. We do not control the content or links that appear on these sites.
        </p>

        <h2>7. Changes to this Privacy Policy</h2>
        <p>
          We reserve the right to update or revise our Privacy Policy at any time. Any changes will be posted on this page.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;
